import * as types from '../actions/types';

const initialState = {
    searchfaqdata: [],
    success: false
}

export default function FaqSearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_FAQ:
            return {

                searchfaqdata: action.payload,
                success: true
            }
        default:
            return state
    }
}
